import { z } from "zod";
import { wishlistTag } from "./wishlistTag";

export const wishlistItem = z.object({
  id: z.number().optional(),
  productId: z.string().optional(),
  variantId: z.string().optional(),
  tags: z.array(wishlistTag).optional(),
});

export type WishlistItem = z.infer<typeof wishlistItem>;
